/**
 * React Query hook to check if current user is in the advanced (Lang Scaffolding) group.
 * Replaces useEffect + apiClient.isUserInLangScaffoldingGroup().
 */
import { useQuery } from '@tanstack/react-query';
import { useAccessToken } from '@app/auth';
import { fetchApi } from '@app/hooks/api';
import { Group } from '../types/formTypes';

const LANG_SCAFFOLDING_GROUP_ID = '317f572f-5195-49c5-a643-f4ed67bf9036';

export function useAdvancedUser() {
    const getToken = useAccessToken();

    const query = useQuery<boolean>({
        queryKey: ['microserviceGenerator', 'advancedUser'],
        queryFn: async () => {
            const response = await fetchApi<{ userGroups: Group[] }>(
                '/api/microservicegenerator/usergroups',
                getToken
            );
            return response.userGroups.some(group => group.id === LANG_SCAFFOLDING_GROUP_ID);
        },
        staleTime: 30 * 60 * 1000, // 30 minutes — group membership rarely changes
        retry: 1,
    });

    return {
        isAdvancedUser: query.data ?? false,
        isLoading: query.isLoading,
        error: query.error ? (query.error as Error).message : null,
    };
}
